import ApiService from './ApiService';
import { AppConfig } from '../config';

export default class AssetsApi {
  static async fetch(path: string, options: any = {}) {
    let api = new ApiService(AppConfig.assetsApiUrl);
    return api.fetch(path, options);
  }
}
